import Button, { ButtonModeE } from "../../components/Button/Button";
import { H1 } from "../../components/Text/Text";
import { BroadcasterT } from "../../models/models";
import SelectBroadcastersBody from "./SelectBroadcastersBody";

import styles from './selectBroadcasters.module.scss';

export default (
    allBroadcasters: BroadcasterT[],
    selectedBroadcasters: BroadcasterT[],
    handleSelect: (selectedBroadcasters: number[]) => void,
    removePopup: () => void,
) => ({
    header: <H1>Select Broadcasters</H1>,
    body: <SelectBroadcastersBody
        allBroadcasters={allBroadcasters}
        selectedBroadcasters={selectedBroadcasters}
        handleSelect={handleSelect}
    />,
    footer: (
        <div className={styles.footerButtonsWrapper}>
            <Button
                onClick={removePopup}
                mode={ButtonModeE.OUTLINED}
            >
                Cancel
            </Button>
            <Button form="select-broadcasters">Save</Button>
        </div>
    ),
    className: styles.popupWrapper
})